<template>
  <div>
    <div class="goodsManageSet">
      <div class="banner">
        <img src="../../../assets/images/banner1.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <div class="breadcrumb_icon">
          <i class="iconfont icon-shangpinsku"></i>
        </div>
        <div class="breadcrumb_item">SKU管理</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">商品管理</div>
      </div>

      <div class="main_content">
        <div class="tit">商品基础信息设置</div>
        <div class="block">
          <h1><span class="mark">*</span>商品名称</h1>
          <div class="block_wrap">
            <p>中文名称</p>
            <div class="input_box">
              <van-field
                v-model="formData.commodityname"
                placeholder="输入商品中文名称"
                @focus="inputFocus"
                @blur="inputBlur"
                maxlength="50"
              />
            </div>
          </div>
          <div class="block_wrap">
            <p>英文名称</p>
            <div class="input_box">
              <van-field
                v-model="formData.commodityname_e"
                placeholder="Enter product name"
                @focus="inputFocus"
                @blur="inputBlur"
              />
            </div>
          </div>
          <div class="block_wrap">
            <p>越南语名称</p>
            <div class="input_box">
              <van-field
                v-model="formData.commodityname_y"
                placeholder="Nhập tên sản phẩm"
                @focus="inputFocus"
                @blur="inputBlur"
              />
            </div>
          </div>
          <div class="block_wrap">
            <p>俄语名称</p>
            <div class="input_box">
              <van-field
                v-model="formData.commodityname_m"
                placeholder="Masukkan nama produk"
                @focus="inputFocus"
                @blur="inputBlur"
              />
            </div>
          </div>
          <div class="block_wrap">
            <p>泰语名称</p>
            <div class="input_box">
              <van-field
                v-model="formData.commodityname_t"
                placeholder="ป้อนชื่อสินค้า"
                @focus="inputFocus"
                @blur="inputBlur"
              />
            </div>
          </div>
          <div class="block_wrap">
            <p>日语名称</p>
            <div class="input_box">
              <van-field
                v-model="formData.commodityname_r"
                placeholder="日本語の名称です"
                @focus="inputFocus"
                @blur="inputBlur"
              />
            </div>
          </div>
        </div>

        <div class="block">
          <div class="item">
            <h1>商品SKU采购编码：</h1>
            <p>{{ detail.sku }}</p>
          </div>
          <div class="item">
            <h1>商品ISBN编码：</h1>
            <p>{{ detail.ISBN }}</p>
          </div>
          <div class="item">
            <h1>商品品牌：</h1>
            <p>{{ detail.brandname }}</p>
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>商品简称</h1>
          <div class="block_wrap">
            <p>中文简称</p>
            <div class="input_box">
              <van-field
                v-model="formData.shortname"
                placeholder="输入商品中文名称"
                @focus="inputFocus"
                @blur="inputBlur"
                maxlength="30"
              />
            </div>
          </div>
          <div class="block_wrap">
            <p>英文简称</p>
            <div class="input_box">
              <van-field
                v-model="formData.shortname_e"
                placeholder="Enter product name"
                @focus="inputFocus"
                @blur="inputBlur"
                maxlength="30"
              />
            </div>
          </div>
          <div class="block_wrap">
            <p>越南语简称</p>
            <div class="input_box">
              <van-field
                v-model="formData.shortname_y"
                placeholder="Nhập tên sản phẩm"
                @focus="inputFocus"
                @blur="inputBlur"
                maxlength="30"
              />
            </div>
          </div>
          <div class="block_wrap">
            <p>俄语简称</p>
            <div class="input_box">
              <van-field
                v-model="formData.shortname_m"
                placeholder="Masukkan nama produk"
                @focus="inputFocus"
                @blur="inputBlur"
                maxlength="30"
              />
            </div>
          </div>
          <div class="block_wrap">
            <p>泰语简称</p>
            <div class="input_box">
              <van-field
                v-model="formData.shortname_t"
                placeholder="ป้อนชื่อสินค้า"
                @focus="inputFocus"
                @blur="inputBlur"
                maxlength="30"
              />
            </div>
          </div>
          <div class="block_wrap">
            <p>日语简称</p>
            <div class="input_box">
              <van-field
                v-model="formData.shortname_r"
                placeholder="日本語の略称です"
                @focus="inputFocus"
                @blur="inputBlur"
                maxlength="30"
              />
            </div>
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>商品类型</h1>
          <!-- <div class="input_box flex-between" @click="handleShowpopup(1)">
            <van-field
              v-model="formData.comtype"
              placeholder="请选择商品类型"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div> -->
          <div class="radio_box">
            <van-radio-group v-model="formData.comtype">
              <van-radio
                v-for="item in columnsGoodsType"
                :key="item"
                :name="item"
                >{{ item }}</van-radio
              >
              <!-- <van-radio name="1">单选框 1</van-radio> -->
            </van-radio-group>
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>商品所属分类</h1>
          <div class="radio_box">
            <p>请选择一级分类</p>
            <van-radio-group
              v-model="formData.labelid"
              @click="handleChangeLabel1($event, true)"
            >
              <van-radio
                v-for="item in labelChilds1"
                :key="item.id"
                :name="item.id"
                >{{ item.labelname }}</van-radio
              >
            </van-radio-group>
          </div>
          <div class="radio_box" v-if="labelChilds2.length > 0">
            <p>请选择二级分类</p>
            <van-radio-group
              v-model="formData.labelid2"
              @click="handleChangeLabel2($event, true)"
            >
              <van-radio
                v-for="item in labelChilds2"
                :key="item.id"
                :name="item.id"
                >{{ item.labelname }}</van-radio
              >
            </van-radio-group>
          </div>
          <div class="radio_box" v-if="labelChilds3.length > 0">
            <p>请选择三级分类</p>
            <van-radio-group v-model="formData.labelid3">
              <van-radio
                v-for="item in labelChilds3"
                :key="item.id"
                :name="item.id"
                >{{ item.labelname }}</van-radio
              >
            </van-radio-group>
          </div>
          <!-- <div class="input_box flex-between" @click="handleShowShopLabelFirst">
            <van-field
              type="text"
              v-model="detail.labelname"
              placeholder="请选择一级分类"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div>
          <div
            class="input_box flex-between"
            @click="handleShowShopLabelSecond"
          >
            <van-field
              type="text"
              v-model="detail.labelname2"
              placeholder="请选择二级分类"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div>
          <div class="input_box flex-between" @click="handleShowShopLabelThree">
            <van-field
              type="text"
              v-model="detail.labelname3"
              placeholder="请选择三级分类"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div> -->
        </div>

        <div class="block">
          <h1><span class="mark">*</span>商品结算类型</h1>
          <!-- <div class="input_box flex-between" @click="handleShowpopup(2)">
            <van-field
              v-model="formData.paytype"
              placeholder="请选择商品结算类型"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div> -->
          <div class="radio_box">
            <van-radio-group v-model="formData.paytype">
              <van-radio
                v-for="item in columnsGoodsSettleType"
                :key="item"
                :name="item"
                >{{ item }}</van-radio
              >
            </van-radio-group>
          </div>
        </div>
        <!-- 
        <div class="block">
          <h1>商品批发组规格（多少件商品为/1组）</h1>
          <div class="input_box">
            <van-field
              v-model="formData.groupnum"
              placeholder="请输入每组商品内商品的数量"
              type="number"
            />
          </div>
        </div> -->

        <div class="block">
          <h1><span class="mark">*</span>是否提供Ai试穿服务</h1>
          <div class="radio_box">
            <van-radio-group v-model="formData.isableware">
              <van-radio name="是">是</van-radio>
              <van-radio name="否">否</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="block"></div>
      </div>

      <div class="primary-button" @click="query">保存确认</div>

      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div>
    </div>

    <van-popup v-model="isShow" round position="bottom" class="brandPopup">
      <div class="block" v-if="isShowType == 1">
        <van-picker
          title="商品类型"
          show-toolbar
          :columns="columnsGoodsType"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
      <div class="block" v-if="isShowType == 2">
        <van-picker
          title="结算类型"
          show-toolbar
          :columns="columnsGoodsSettleType"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
      <div class="block" v-if="isShowType == 3">
        <van-picker
          title="商品一级分类"
          show-toolbar
          :columns="shopLabelFirst"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
      <div class="block" v-if="isShowType == 4">
        <van-picker
          title="商品二级分类"
          show-toolbar
          :columns="shopLabelSecond"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
      <div class="block" v-if="isShowType == 5">
        <van-picker
          title="商品三级分类"
          show-toolbar
          :columns="shopLabelThree"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  getCommidityDetail,
  getCommondityLabel,
  editCommidity,
  encryptstringview,
} from "../../../api/api";
import { mapState } from "vuex";
export default {
  name: "cBaseinfo",
  data() {
    return {
      isShowType: 1,
      isShow: false,
      columnsGoodsType: [
        "普通商品",
        "普通用户积分礼品",
        "商务用户积分礼品",
        "企业积分商品",
      ],
      columnsGoodsSettleType: [
        "零售或批发购买",
        "普通用户积分兑换",
        "商户合作用户积分兑换",
        "企业积分",
      ],

      // shopLabel: "",
      // shopLabelFirst: [],
      // shopLabelSecond: [],
      // shopLabelThree: [],
      allLabel: [],
      labelChilds1: [],
      labelChilds2: [],
      labelChilds3: [],

      cmid: "",
      detail: "",
      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        commodityname: "",
        commodityname_e: "",
        commodityname_m: "",
        commodityname_y: "",
        commodityname_t: "",
        commodityname_r: "",
        shortname: "",
        shortname_e: "",
        shortname_m: "",
        shortname_y: "",
        shortname_t: "",
        shortname_r: "",
        comtype: "",
        labelid: "",
        labelid2: "",
        labelid3: "",
        paytype: "",
        isableware: ''  // 是否试穿 是、否
      },
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.cmid = id;
        this.getShopLabel();
      } else {
        this.$router.back();
      }
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },

    getDetail() {
      let { cmid } = this;
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getCommidityDetail({ id: cmid }).then((res) => {
        this.detail = res;
        this.formData.id = res.id ? res.id : "";
        this.formData.commodityname = res.commodityname
          ? res.commodityname
          : "";
        this.formData.commodityname_e = res.commodityname_e
          ? res.commodityname_e
          : "";
        this.formData.commodityname_m = res.commodityname_m
          ? res.commodityname_m
          : "";
        this.formData.commodityname_y = res.commodityname_y
          ? res.commodityname_y
          : "";
        this.formData.commodityname_t = res.commodityname_t
          ? res.commodityname_t
          : "";
        this.formData.commodityname_r = res.commodityname_r
          ? res.commodityname_r
          : "";
        this.formData.shortname = res.shortname ? res.shortname : "";
        this.formData.shortname_e = res.shortname_e ? res.shortname_e : "";
        this.formData.shortname_m = res.shortname_m ? res.shortname_m : "";
        this.formData.shortname_y = res.shortname_y ? res.shortname_y : "";
        this.formData.shortname_t = res.shortname_t ? res.shortname_t : "";
        this.formData.shortname_r = res.shortname_r ? res.shortname_r : "";
        this.formData.comtype = res.comtype ? res.comtype : "";
        this.formData.labelid = res.labelid ? res.labelid : "";
        this.formData.labelid2 = res.labelid2 ? res.labelid2 : "";
        this.formData.labelid3 = res.labelid3 ? res.labelid3 : "";
        this.formData.paytype = res.paytype ? res.paytype : "";
        this.formData.isableware = res.isableware ? res.isableware : "";
        if (res.labelid) {
          this.handleChangeLabel1(res.labelid);
        }
        if (res.labelid2) {
          this.handleChangeLabel2(res.labelid2);
        }
        Toast.clear();
      });
    },

    // 获取商品分类标签
    getShopLabel() {
      getCommondityLabel().then((res) => {
        let filter = res
          .filter((v) => v.labelstate == 1)
          .sort((a, b) => a.sort - b.sort);
        this.allLabel = filter;
        this.labelChilds1 = filter;
        this.getDetail();
      });
    },
    // 触发一级分类，获取二级数据
    handleChangeLabel1(e, isClick) {
      let { allLabel } = this;
      let labelChilds2 = [];
      allLabel.forEach((v) => {
        if (v.id == e) {
          labelChilds2 = v.childs2;
        }
      });
      this.labelChilds2 = labelChilds2
        .filter((item) => item.labelstate === "1")
        .sort((a, b) => a.sort - b.sort);
      if (isClick) {
        this.labelChilds3 = [];
        this.formData.labelid2 = "";
        this.formData.labelid3 = "";
      }
    },
    // 触发二级分类，获取三级数据
    handleChangeLabel2(e, isClick) {
      let { labelChilds2 } = this;
      let labelChilds3 = [];
      labelChilds2.forEach((v) => {
        if (v.id == e) {
          labelChilds3 = v.childs3;
        }
      });
      this.labelChilds3 = labelChilds3
        .filter((item) => item.labelstate === "1")
        .sort((a, b) => a.sort - b.sort);
      if (isClick) {
        this.formData.labelid3 = "";
      }
    },

    // 获取商品分类标签
    // getShopLabel() {
    //   const Toast = this.$toast.loading({
    //     message: "加载中...",
    //     forbidClick: true,
    //   });
    //   let dataNew = [];
    //   getCommondityLabel().then((res) => {
    //     res.forEach((v) => {
    //       dataNew.push({
    //         text: v.labelname,
    //         value: v.id,
    //         child: v.childs2,
    //       });
    //     });
    //     this.shopLabel = res;
    //     this.shopLabelFirst = dataNew;
    //     Toast.clear();
    //   });
    // },

    handleShowShopLabelFirst() {
      this.isShow = true;
      this.isShowType = 3;
    },
    handleShowShopLabelSecond() {
      let { formData, shopLabelFirst } = this;
      if (formData.labelid == "") {
        this.$toast("请选择商品一级分类");
        return;
      }
      let childs2New = [];
      shopLabelFirst.forEach((v) => {
        if (v.value == formData.labelid) {
          if (v.child.length > 0) {
            v.child.map((v1) => {
              childs2New.push({
                text: v1.labelname,
                value: v1.id,
                child: v1.childs3,
              });
            });
            this.shopLabelSecond = childs2New;
            this.isShow = true;
            this.isShowType = 4;
          } else {
            this.$toast("赞无二级分类");
            return;
          }
        }
      });
    },
    handleShowShopLabelThree() {
      let { shopLabelSecond, formData } = this;
      let childs2New = [];
      shopLabelSecond.forEach((v) => {
        if (v.value == formData.labelid2) {
          if (v.child.length > 0) {
            v.child.map((v1) => {
              childs2New.push({
                text: v1.labelname,
                value: v1.id,
              });
            });
            this.shopLabelThree = childs2New;
            this.isShow = true;
            this.isShowType = 5;
          } else {
            this.$toast("赞无二级分类");
            return;
          }
        }
      });
    },

    // 显示弹窗
    handleShowpopup(type) {
      if (type == 1) {
        this.isShowType = 1;
      } else if (type == 2) {
        this.isShowType = 2;
      }
      this.isShow = true;
    },
    onConfirm(e) {
      let { isShowType } = this;
      if (isShowType == 1) {
        this.formData.comtype = e;
      } else if (isShowType == 2) {
        this.formData.paytype = e;
      } else if (isShowType == 3) {
        let { text, value } = e;
        this.formData.labelid = value;
        this.detail.labelname = text;
        this.formData.labelid2 = "";
        this.detail.labelname2 = "";
        this.formData.labelid3 = "";
        this.detail.labelname3 = "";
      } else if (isShowType == 4) {
        let { text, value } = e;
        this.formData.labelid2 = value;
        this.detail.labelname2 = text;
        this.formData.labelid3 = "";
        this.detail.labelname3 = "";
      } else if (isShowType == 5) {
        let { text, value } = e;
        this.formData.labelid3 = value;
        this.detail.labelname3 = text;
      }
      this.isShow = false;
    },

    query() {
      let { formData, label_name } = this;
      if (formData.commodityname == "") {
        this.$toast("请输入商品名称");
        return;
      }
      if (formData.commodityname.length < 2) {
        this.$toast("请输入商品名称最少2个字符");
        return;
      }
      if (formData.shortname.length < 2) {
        this.$toast("请输入商品简称最少2个字符");
        return;
      }
      if (formData.shortname_e.length > 0) {
        if (formData.shortname_e.length < 2) {
          this.$toast("请输入商品简称最少2个字符");
          return;
        }
      }
      if (formData.shortname_m.length > 0) {
        if (formData.shortname_m.length < 2) {
          this.$toast("请输入商品简称最少2个字符");
          return;
        }
      }
      if (formData.shortname_y.length > 0) {
        if (formData.shortname_y.length < 2) {
          this.$toast("请输入商品简称最少2个字符");
          return;
        }
      }
      if (formData.shortname_t.length > 0) {
        if (formData.shortname_t.length < 2) {
          this.$toast("请输入商品简称最少2个字符");
          return;
        }
      }
      // label_name
      // paytype
      if (formData.comtype == "") {
        this.$toast("请选择商品类型");
        return;
      }
      if (label_name == "") {
        this.$toast("请选择商品分类");
        return;
      }
      if (formData.paytype == "") {
        this.$toast("请选择商品结算类型");
        return;
      }
      // if (formData.groupnum.length > 0) {
      //   if (formData.groupnum.length < 2) {
      //     this.$toast("请输入每组商品内商品的数量最少2个字符");
      //     return;
      //   }
      // }
      if (formData.isableware == "") {
        this.$toast("请选择是否提供Ai试穿服务");
        return;
      }
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      editCommidity(formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(res.message);
          }, 500);
          // setTimeout(() => {
          //   history.back();
          // }, 1500);
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      history.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      .radio_box {
        .van-radio {
          margin-bottom: 10px;
        }
      }
      .block_wrap {
        width: 600px;
        margin: auto;
        p {
          // text-align: left;
          font-size: 24px;
          color: #444444;
          margin-bottom: 10px;
        }
      }
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .item {
        margin-bottom: 50px;
      }
      .input_box,
      .select_box {
        margin-bottom: 30px;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
    }
  }
}
</style>